import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import noNotifications from 'assets/images/no-notifications.png'

export const NoViewers = () => {
    const { t } = useTranslation()

    return (
        <Container>
            <img
                src={noNotifications}
                alt='noViewers'
                width={120}
                height={120}
            />

            <TextWrapper>
                <Title>{t('noViewers')}</Title>
                <Description>{t('noViewersDescription')}</Description>
            </TextWrapper>
        </Container>
    )
}

const Container = styled.div`
    height: 30rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    img {
        width: 12rem;
        height: 12rem;
        object-fit: contain;
    }
`

const TextWrapper = styled.div`
    text-align: center;
`

const Title = styled.div`
    color: #cfd0da;
    text-align: center;
    letter-spacing: 0.48px;
    font-size: 2.4rem;
    font-weight: 600;
`

const Description = styled.div`
    color: #cfd0da;
    text-align: center;
    letter-spacing: 0.28px;
    font-size: 1.4rem;
`
